import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectInlinePreviewsOption')(function selectInlinePreviewsOption(isInlinePreviewsEnabled, state) {
    var optionState = state.optionState;
    optionState.isEnabled = isInlinePreviewsEnabled;
}));
//# sourceMappingURL=selectInlinePreviewsOption.js.map